import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LineEnding_Default_instance;
var LineEnding_Lenient_instance;
var LineEnding_entriesInitialized;
function LineEnding_initEntries() {
  if (LineEnding_entriesInitialized)
    return Unit_instance;
  LineEnding_entriesInitialized = true;
  LineEnding_Default_instance = new (LineEnding())('Default', 0);
  LineEnding_Lenient_instance = new (LineEnding())('Lenient', 1);
}
var LineEndingClass;
function LineEnding() {
  if (LineEndingClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'LineEnding');
    LineEndingClass = $;
  }
  return LineEndingClass;
}
function LineEnding_Default_getInstance() {
  LineEnding_initEntries();
  return LineEnding_Default_instance;
}
function LineEnding_Lenient_getInstance() {
  LineEnding_initEntries();
  return LineEnding_Lenient_instance;
}
//region block: exports
export {
  LineEnding_Default_getInstance as LineEnding_Default_getInstance3rv7nlgborrds,
  LineEnding_Lenient_getInstance as LineEnding_Lenient_getInstanceagvw5ljm3cic,
};
//endregion

//# sourceMappingURL=LineEnding.mjs.map
